import { useState } from 'react';
import { useI18n } from '../hooks/use-i18n';

const DEFAULT_TAGLINE_KEYS = {
  Innovate: 'innovate.tagline',
  Digest:   'digest.tagline',
  Playbook: 'playbook.tagline',
  Space:    'space.tagline',
  Ideas:    'ideas.empty_sub',
  Notes:    'notes.title',
  Signal:   'signal.tagline',
};

export default function ShiftPanelHeader({
  title,
  tagline,
  tabs,
  activeTab,
  onTabChange,
  actionButton,
  actionButtons,
  onClose,
  taglineInline,
}) {
  const { t } = useI18n();
  const [closeHover, setCloseHover] = useState(false);

  const resolvedTagline = tagline || t(DEFAULT_TAGLINE_KEYS[title] || '', '') || '';

  return (
    <>
      {/* ROW 1 — Header */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center',
        padding: '16px 24px',
        borderBottom: '0.5px solid #272736',
        background: '#07070a',
      }}>
        {/* Left */}
        {taglineInline ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#c8a96e', fontFamily: 'Georgia, serif', letterSpacing: '0.04em' }}>
              {title}
            </div>
            {resolvedTagline && (
              <div style={{ fontSize: 12, color: 'var(--text-5)', fontStyle: 'italic', fontFamily: 'Georgia, serif' }}>
                {resolvedTagline}
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px' }}>
            <span style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#c8a96e',
              fontFamily: 'Georgia, serif',
            }}>
              {title}
            </span>
            {resolvedTagline && (
              <span style={{
                fontSize: '13px',
                color: '#888888',
                fontStyle: 'italic',
                fontFamily: 'Georgia, serif',
              }}>
                {resolvedTagline}
              </span>
            )}
          </div>
        )}

        {/* Right */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {(actionButtons || (actionButton ? [actionButton] : [])).map((btn, i) => (
            <div
              key={i}
              onClick={btn.onClick}
              style={{
                background: 'transparent',
                border: `1px solid ${btn.color || '#7a9e82'}`,
                borderRadius: '6px',
                color: btn.color || '#7a9e82',
                fontSize: '12px',
                fontFamily: 'Georgia, serif',
                padding: '7px 18px',
                cursor: 'pointer',
                letterSpacing: '0.04em',
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = `${btn.color || '#7a9e82'}14`; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
            >
              {btn.label}
            </div>
          ))}
          <div
            onClick={onClose}
            onMouseEnter={() => setCloseHover(true)}
            onMouseLeave={() => setCloseHover(false)}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path
                d="M1 1L11 11M11 1L1 11"
                stroke={closeHover ? '#c46050' : '#555555'}
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* ROW 2 — Navigation */}
      {tabs && tabs.length > 0 && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '4px',
          padding: '0 24px',
          borderBottom: '0.5px solid #272736',
          background: '#07070a',
        }}>
          {tabs.map(tab => (
            <div
              key={tab.label}
              onClick={() => onTabChange(tab.label)}
              style={{
                fontSize: '18px',
                fontFamily: 'Georgia, serif',
                padding: '12px 16px',
                cursor: 'pointer',
                color: activeTab === tab.label ? tab.color : '#888888',
              }}
            >
              {tab.label}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
